const BOARD_SLUG_SEGMENT = "[a-z0-9](?:[a-z0-9-]{0,30}[a-z0-9])?";
const THREAD_ID_SEGMENT =
  "[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}";
const BOARD_SLUG_PATTERN = new RegExp(`^${BOARD_SLUG_SEGMENT}$`);
const THREAD_URL_PATTERN = new RegExp(
  `^/(?:b|mix)/(${BOARD_SLUG_SEGMENT})/thread/(${THREAD_ID_SEGMENT})/?$`,
);

export type ThreadCanonicalLocation = Readonly<
  Pick<Location, "origin" | "pathname" | "search" | "hash">
>;

/**
 * state応答が示す現在板と開いているスレURLが異なる場合のみ、
 * 板ネイティブのcanonical URLを返す。
 */
export function resolveMovedThreadCanonicalUrl(
  location: ThreadCanonicalLocation,
  threadId: string,
  actualSlug: string | null,
): string | null {
  if (actualSlug === null || !BOARD_SLUG_PATTERN.test(actualSlug)) return null;

  const match = THREAD_URL_PATTERN.exec(location.pathname);
  const requestedSlug = match?.[1];
  const pathThreadId = match?.[2];
  if (
    requestedSlug === undefined ||
    pathThreadId === undefined ||
    requestedSlug === actualSlug ||
    pathThreadId.toLowerCase() !== threadId.toLowerCase()
  ) {
    return null;
  }

  return `${location.origin}/b/${actualSlug}/thread/${pathThreadId.toLowerCase()}${location.search}${location.hash}`;
}
